import { render, staticRenderFns } from "./ResumeLanguageItem.vue?vue&type=template&id=3e116772&"
import script from "./ResumeLanguageItem.vue?vue&type=script&lang=js&"
export * from "./ResumeLanguageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports